import { Route, Routes } from 'react-router-dom';
import WopiPage from './pages/WopiPage/WopiPage';

const ExtensionsContainer = () => {
  return (
    <Routes>
      <Route path="/wopi/:id/:applicationId/:actionId" element={<WopiPage />} />
    </Routes>
  );
};

export default ExtensionsContainer;
